var _defs, _circle, _circle2, _g, _ellipse, _path, _path2, _rect, _ellipse2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "bgGradient",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fef9c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#bbf7d0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "plantGradient",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#34d399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#059669"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sunGradient",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fde68a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fbbf24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stemGradient",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4ade80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#166534"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "url(#bgGradient)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 16,
    r: 10,
    fill: "url(#sunGradient)",
    opacity: 0.85
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 10,
    r: 1.5,
    fill: "#fffbe6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 8,
    r: 1,
    fill: "#fffbe6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 22,
    r: 1,
    fill: "#fffbe6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 28,
    r: 1.2,
    fill: "#fffbe6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 18,
    r: 0.8,
    fill: "#fffbe6"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 40,
    rx: 13,
    ry: 19,
    fill: "url(#plantGradient)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 40 Q28 28 16 24 Q28 26 32 12 Q36 26 48 24 Q36 28 32 40 Z",
    fill: "#059669",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 40 Q30 30 22 28 Q30 32 32 18 Q34 32 42 28 Q34 30 32 40 Z",
    fill: "#34d399",
    fillOpacity: 0.7
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 40,
    width: 6,
    height: 14,
    rx: 3,
    fill: "url(#stemGradient)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 54,
    rx: 4,
    ry: 2,
    fill: "#047857",
    fillOpacity: 0.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 18,
    r: 2,
    fill: "#a7f3d0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.2,
    y: 16.2,
    width: 1.6,
    height: 3.6,
    rx: 0.8,
    fill: "#34d399"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.2,
    y: 17.2,
    width: 3.6,
    height: 1.6,
    rx: 0.8,
    fill: "#34d399"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2636e507f7d875bf8c2d9f33616a8adc.svg";
export { ForwardRef as ReactComponent };